import React, { PropTypes } from 'react';

const CardBlock = ({ children, className }) => {
    return (
        <div className={`card-block${className ? ` ${className}` : ''}`}>
            {children}
        </div>
    );
};

CardBlock.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string
};

export default CardBlock;


/** WEBPACK FOOTER **
 ** ./src/components/bootstrap/CardBlock.js
 **/